<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    size="md"
    title="Create a new scan facility"
    title-tag="h5"
    cancel-title="Cancel"
    id="idBranchDetailNewScanFacilityModal"
    cancel-variant="outline-primary"
    :ok-disabled="scanFacilityName === ''"
    :ok-title="this.$store.state.facility ? 'Update' : 'Create'"
    @hidden="clearData"
    @shown="focusFirstInput"
    @show="onShow"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <b-col>
          <label class="required" for="idScanFacilityName"
            >Scan Facility Name</label
          >
          <b-form-input
            size="sm"
            id="idScanFacilityName"
            trim
            ref="firstInput"
            v-model="scanFacilityName"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label for="idCity">City</label>
          <b-form-input
            size="sm"
            id="idCity"
            trim
            v-model="city"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label for="idState">State</label>
          <b-form-input
            size="sm"
            id="idState"
            trim
            v-model="state"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label for="idCountry">Country</label>
          <b-form-input
            size="sm"
            id="idCountry"
            trim
            v-model="country"
          ></b-form-input>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      scanFacilityName: "",
      city: null,
      state: null,
      country: null,
    };
  },
  created() {},
  methods: {
    focusFirstInput() {
      this.$refs.firstInput.focus();
    },
    onShow() {
      if (this.$store.state.facility) {
        this.id = this.$store.state.facility.id;
        this.scanFacilityName = this.$store.state.facility.scanFacilityName;
        this.city = this.$store.state.facility.city;
        this.state = this.$store.state.facility.state;
        this.country = this.$store.state.facility.country;
      }
    },
    onOk() {
      if (this.$store.state.facility) {
        this.$emit("updateScanFacility", {
          id: this.$store.state.facility.id,
          facilityName: this.scanFacilityName,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      } else {
        this.$emit("newScanFacility", {
          facilityName: this.scanFacilityName,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      }
    },
    clearData() {
      this.$store.commit("SET_FACILITY_TO_EDIT", null);
      this.scanFacilityName = "";
      this.city = "";
      this.state = "";
      this.country = "";
    },
  },
};
</script>

<style scoped>
.row {
  margin: 0.8rem 0;
}
</style>